import { Indicator } from '../../../Common/Charts/Indicator';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const WeightLess25kgxLess6ConsultationsPrenatal = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <Indicator
            title={'Peso menor que 2,5kg x Menos de 6 consultas pré-natal'}
            indicatorValue={chartData?.indicators?.weightLess25kgxLess6ConsultationsPrenatal}
            className='aligned-container'
        />
    );
};
